import { getUriQueryParameter } from '@impuls-coach/util-get-uri-query-parameter';
import i18n from 'helper/i18n';
import { getIsAuthenticated } from 'store/login';
import {
	getActivityLevel,
	getAllergies,
	getCoach,
	getError,
	getGender,
	getGenderMeta,
	getHeight,
	getIsPregnant,
	getIsUpdatingAnamnesis,
	getNutritionPhilosophy,
	getUserData,
	getWaitForValues,
	getWeight,
} from 'store/profile';
import { IRootState } from 'store/rootReducer';
import { WithRouterType } from 'types/withRouter';

export const mapParentStateToProps = (state: IRootState, props: WithRouterType) => {
	const referrer = getUriQueryParameter('referrer');
	const saveButton = (type?: '' | 'disabled' | 'like') => ({
		type,
		labelBottom: i18n('react.impulsCoach.components.anamnesis.saveCaption'),
		knob: {
			modifier: 'dashed',
			icon: 'completed' as 'completed',
			size: 'l' as 'l',
		},
	});
	const arrowLeftButton = () => ({
		knob: {
			modifier: '',
			icon: 'arrow-left' as 'arrow-left',
			size: 'l' as 'l',
		},
	});
	return {
		router: props.history,
		isAuthenticated: getIsAuthenticated(state),
		isUpdatingAnamnesis: getIsUpdatingAnamnesis(state),
		userData: getUserData(state),
		error: getError(state),
		coach: getCoach(state),
		gender: getGender(state),
		weight: getWeight(state),
		size: getHeight(state),
		isPregnant: getIsPregnant(state),
		genderMeta: getGenderMeta(state),
		nutritionPhilosophy: getNutritionPhilosophy(state),
		allergies: getAllergies(state),
		activityLevel: getActivityLevel(state),
		waitForValues: getWaitForValues(state),
		referrer,
		actionButtonsInactive: {
			buttonsLayout: 'back',
			buttons: [arrowLeftButton(), saveButton('disabled')],
		},
		actionButtonsActive:
			typeof referrer === 'string' && referrer !== ''
				? {
						buttonsLayout: 'link',
						buttons: [saveButton()],
				  }
				: {
						buttonsLayout: 'back',
						buttons: [arrowLeftButton(), saveButton()],
				  },
	};
};

export type IAnamnesisContainerProps = ReturnType<typeof mapParentStateToProps>;
